import React, { useMemo, useState } from 'react';

import ModalViewImageChatbot from '../ModalViewImageChatbot';

import ImageMessage, { ImageMessageItemTypes } from 'components/molecules/ImageMessage';
import MessageFile, { MessageFileProps } from 'components/molecules/MessageFile';
import { detectFileType, formatBytes, getFileExtension } from 'utils/functions';

interface RenderFileProps {
  files: UploadFileType[]
}

const RenderFile: React.FC<RenderFileProps> = ({ files }) => {
  const [previewImg, setPreviewImg] = useState<string | undefined>(undefined);

  const imagesView = useMemo(() => files.filter((item) => (item.file || item.fileView)?.type.includes('image')).map((im) => ({
    alt: 'image',
    id: im.fileSubmit?.code || im.fileView?.code,
    src: im.fileSubmit?.path || im.fileView?.path || ''
  } as ImageMessageItemTypes)) || [], [files]);

  const filesView = useMemo(() => files.filter((item) => !(item.file || item.fileView)?.type.includes('image')).map((fi) => ({
    status: fi.status,
    fileIcon: 'fileOutline',
    fileName: fi.file?.name || fi.fileView?.name,
    fileSize: fi.file?.size
      ? formatBytes(fi.file?.size) : formatBytes(Number(fi.fileView?.size) || 0),
    fileType: (fi?.file?.type || fi.fileView?.type)
      ? getFileExtension(fi?.file?.name || fi.fileView?.name || '')
      : detectFileType(fi?.file?.type || fi.fileView?.type),
  } as MessageFileProps)) || [], [files]);

  return (
    <div className="o-renderFile">
      {imagesView.length > 0 && (
        <ImageMessage
          images={imagesView}
          isSmall={imagesView.length > 3}
          isShowRemove={false}
          onClick={(url) => setPreviewImg(url)}
        />
      )}
      {filesView.length > 0
        && filesView.map((item, idx) => (
          <div key={`file-item-${idx.toString()}`}>
            <MessageFile type="file" {...item} fileIcon={item.fileIcon || 'fileOutline'} fileSize={item.fileSize} isForDisplay />
          </div>
        ))}

      <ModalViewImageChatbot
        imgUrl={previewImg || ''}
        onClose={() => setPreviewImg(undefined)}
      />
    </div>
  );
};

export default RenderFile;
